import React from 'react';
import cls from 'classnames';
import PropTypes from 'prop-types';

import {
  Table,
  TableBody,
  TableCell,
  TableFooter,
  TableHead,
  TablePagination,
  TableRow,
  Typography,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { Portlet, PortletContent } from '../../../../../components';
import { ContestComissionTablePagination } from './ContestComissionTablePagination';
import { ContestComissionTableRow } from './ContestComissionTableRow';
import BeneficiosSortButton from '../../BeneficiosMGM/BeneficiosSortButton';
import styles from './ContestComissionTable.styles';

const useStyles = makeStyles(styles);

export const ContestComissionTable = props => {
  const classes = useStyles();
  const { data, total, currentPage, rowsPerPage, handleChangePage, handleChangeRowsPerPage, setSorts, sorts } = props;
  const rootClassName = cls(classes.root);

  return (
    <Portlet className={rootClassName}>
      <PortletContent noPadding>
        <div className={classes.tableWrapper}>
          <Table width="100%" className={classes.tableContainer}>
            <TableHead className={classes.tableHead}>
              <TableRow>
                <TableCell className={classes.tableCell}>
                  <Typography variant="body2">
                    Data de Criação
                    <BeneficiosSortButton
                      column="createdAt"
                      sortState={sorts}
                      onSort={newSort => setSorts({ ...sorts, ...newSort })}
                    />
                  </Typography>
                </TableCell>
                <TableCell className={classes.tableCell}>
                  <Typography variant="body2">
                    Parceiro
                    <BeneficiosSortButton
                      column="partnerId"
                      sortState={sorts}
                      onSort={newSort => setSorts({ ...sorts, ...newSort })}
                    />
                  </Typography>
                </TableCell>
                <TableCell className={classes.tableCell}>
                  <Typography variant="body2">Invoice ID</Typography>
                </TableCell>
                <TableCell className={classes.tableCell}>
                  <Typography variant="body2">Mês de Referência</Typography>
                </TableCell>
                <TableCell className={classes.tableCell}>
                  <Typography variant="body2">Mensagem</Typography>
                </TableCell>
                <TableCell className={classes.tableCell}>
                  <Typography variant="body2">Ações</Typography>
                </TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {!data || data.length === 0 ? (
                <TableRow width="100%" className={classes.tr}>
                  <TableCell className={classes.tableCell} width="100%" colSpan={6}>
                    Ops. Não encontramos nada.
                  </TableCell>
                </TableRow>
              ) : (
                data.map(row => <ContestComissionTableRow key={row?.id || `row-${Math.random()}`} data={row} />)
              )}
            </TableBody>
            <TableFooter>
              <TableRow>
                <TablePagination
                  count={total}
                  page={currentPage - 1}
                  rowsPerPage={rowsPerPage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                  labelRowsPerPage="Registros por página"
                  onPageChange={() => {}}
                  rowsPerPageOptions={[10, 25, 50, 100, 500]}
                  ActionsComponent={() => (
                    <ContestComissionTablePagination
                      total={total}
                      onChangePage={handleChangePage}
                      page={currentPage}
                      rowsPerPage={rowsPerPage}
                    />
                  )}
                />
              </TableRow>
            </TableFooter>
          </Table>
        </div>
      </PortletContent>
    </Portlet>
  );
};

ContestComissionTable.propTypes = {
  data: PropTypes.array.isRequired,
  total: PropTypes.number.isRequired,
  currentPage: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
  handleChangePage: PropTypes.func.isRequired,
  handleChangeRowsPerPage: PropTypes.func.isRequired,
  setSorts: PropTypes.func.isRequired,
  sorts: PropTypes.object.isRequired,
};
